<template lang="pug">
	section.section.main-section
		.container.container-narrow
			title-comp(:name="$t('title.ranks')")

			article.message.is-success(v-if="emptyPage")
				.message-body
					| {{ $t('ranking.empty') }}

			article.message.is-danger(v-if="errorPage")
				.message-body
					| {{ $t('alert.error') }}

			.tabs.is-centered
				ul
					li(v-bind:class="tabMonthClass")
						a(@click="changeTab", tab="month") {{ $t('ranking.tab_month') }}
					li(v-bind:class="tabFullClass")
						a(@click="changeTab", tab="full") {{ $t('ranking.tab_full') }}

			article.message.is-warning(v-if="!loading && !emptyPage && ((activeTab === 'month' && ranksMonth.length === 0) || (activeTab === 'full' && ranksFull.length === 0))")
				.message-body
					| {{ $t('ranking.empty') }}

			.box(v-else-if="activeTab === 'month'")
				.table-container
					table.table(v-if="!loading")
						thead
							tr
								th
									abbr(:title="$t('ranking.position')") #
								th(style="width: 100%;") {{ $t('ranking.name') }}
								th {{ $t('ranking.score') }}
						tbody
							tr(v-for="user, index in ranksMonth" :key="user.uuid")
								th {{ index+1 }}
								td {{ user.nickname ? user.nickname : user.first_name + ' ' + user.last_name }}
								td.no-wrap {{ user.score }}

			.box(v-else-if="activeTab === 'full'")
				.table-container
					table.table(v-if="!loading")
						thead
							tr
								th
									abbr(:title="$t('ranking.position')") #
								th(style="width: 100%;") {{ $t('ranking.name') }}
								th {{ $t('ranking.score') }}
						tbody
							tr(v-for="user, index in ranksFull" :key="user.uuid")
								th {{ index+1 }}
								td {{ user.nickname ? user.nickname : user.first_name + ' ' + user.last_name }}
								td.no-wrap {{ user.score }}

</template>

<script>
import TitleComponent from '../components/TitleComponent.vue'

export default {
	components: {
		TitleComp: TitleComponent
	},
	data() {
		return {
			emptyPage: false,
			errorPage: false,
			activeTab: 'month'
		}
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		ranksMonth() {
			return this.$store.state.rank.ranks_month
		},
		ranksFull() {
			return this.$store.state.rank.ranks_full
		},
		loading() {
			return this.$store.state.rank.loading
		},
		tabMonthClass() {
			return { 'is-active': this.activeTab === 'month' }
		},
		tabFullClass() {
			return { 'is-active': this.activeTab === 'full' }
		}
	},
	mounted() {
		//this.$meta().setOptions({ title: this.$t("title.ranks") + ' | ' + this.$t("title.home") })
		this.refreshRanking()
	},
	methods: {
		refreshRanking() {
			switch (this.activeTab) {
				case 'month':
					return this.refreshRankingMonth()
				case 'full':
					return this.refreshRankingFull()
			}
		},
		refreshRankingMonth() {
			if (this.ranksMonth.length === 0) {
				this.$store.dispatch('rank/getRanksMonth', this.accessToken).then(() => {
					this.emptyPage = false
					this.errorPage = false
				}).catch(err => {
					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 404:
								this.emptyPage = true
								break
							case 500:
								this.errorPage = true
								break
							default:
								console.warn(err.response.status)
						}
					}
				})
			}
		},
		refreshRankingFull() {
			if (this.ranksFull.length === 0) {
				this.$store.dispatch('rank/getRanksFull', this.accessToken).then(() => {
					this.emptyPage = false
					this.errorPage = false
				}).catch(err => {
					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 404:
								this.emptyPage = true
								break
							case 500:
								this.errorPage = true
								break
							default:
								console.warn(err.response.status)
						}
					}
				})
			}
		},
		changeTab(ev) {
			this.activeTab = ev.target.getAttribute('tab')
			this.emptyPage = false
			this.errorPage = false
			this.refreshRanking()
		}
	}
}
</script>
